import React from 'react';
import { Tooltip } from '@mui/material';
import ToolTipContent from '../toolTipContent';
import Away from './away';

const AwayWrapper = (props) => {
   if (
      (props.dayStatus && props.dayStatus.times) ||
      (props.dayStatus && props.dayStatus.bookings !== null)
   ) {
      return (
         <Tooltip
            title={<ToolTipContent dayStatus={props.dayStatus} />}
            placement="top"
            arrow
         >
            <div>
               <Away
                  clickable={props.clickable}
                  styles={props.styles}
                  miniChips={props.miniChips}
                  data={props.data}
                  setSpaceData={props.setSpaceData}
                  setStatusDrawerOpen={props.setStatusDrawerOpen}
               />
            </div>
         </Tooltip>
      );
   } else {
      return (
         <Away
            clickable={props.clickable}
            styles={props.styles}
            miniChips={props.miniChips}
            data={props.data}
            setSpaceData={props.setSpaceData}
            setStatusDrawerOpen={props.setStatusDrawerOpen}
         />
      );
   }
};
export default AwayWrapper;
